export const cleanHtmlValue = (value: string): string => {
  if (typeof value === 'string') {
    return value.replace(/(.*?)<.*?>(.*?)/g, '');
  }
  return value;
};
